import NamespacedSerializer from '@linc-technologies/linced-common/serializers/namespaced';
import {
  normalizeFields,
  serializeFields,
  type FieldHash,
  type SerializableField,
} from '@linc-technologies/linced-common/utils/dynamic-fields-serializer';

// DynamicFieldsSerializer changes the API fields map
// (`map<string, FieldValue> fields`) to and from the record fieldsArray.
// A subclass sets _fieldsKey when the payload key is not `fields` (for
// example `options` for a school), and namespace for a namespaced service.
// This file is not re-exported from app/serializers, so the store cannot use
// it as the serializer of a model.
export default class DynamicFieldsSerializer extends NamespacedSerializer {
  _fieldsKey = 'fields';

  normalize(
    modelClass: unknown,
    hash: Record<string, unknown>,
    prop?: string,
  ): unknown {
    hash['fieldsArray'] = normalizeFields(
      hash[this._fieldsKey] as Record<string, FieldHash> | undefined,
    );
    return super.normalize(modelClass, hash, prop);
  }

  serialize(snapshot: unknown): Record<string, unknown> {
    const json = super.serialize(snapshot, { includeId: true });
    const fieldsArray = (
      snapshot as { record: { fieldsArray?: Iterable<SerializableField> } }
    ).record.fieldsArray;

    if (fieldsArray) {
      delete json['fieldsArray'];
      delete json['fields'];
      json[this._fieldsKey] = serializeFields(fieldsArray);
    }
    return json;
  }
}
